require('../../modules/es7.string.pad-start');
module.exports = require('../../modules/_core').String.padStart;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/string/pad-start.js
// module id = 416
// module chunks = 0